// Datenquelle der Kontaktsuche in der Kopfleiste (#255).
//
// Braucht Telefonnummern von Kunden UND Ansprechpartnern. Die liefert nur die
// Verwaltungs-Route (GET /api/admin/customers, Manager/Admin) -- die offene
// Leseliste /api/customers hat bewusst keine Nummern. Deshalb ist die Suche wie
// der Link zur Kundenverwaltung nur für Manager und Admins sichtbar.
//
// 60 s zwischengespeichert wie customerCache/contactCache: Der Stamm ändert
// sich selten, und die Suche soll beim Tippen nicht jedes Mal laden.
// Inaktive Kunden und Ansprechpartner fallen heraus -- wer anruft, braucht den
// aktuellen Stand; auffindbar bleiben sie in der Kundenverwaltung.
import apiService from '../services/apiService';

const TTL_MS = 60 * 1000;
let cached = null;
let cachedAt = 0;
let pending = null;

export function nurAktive(kunden) {
  return (kunden || [])
    .filter(k => k && k.isActive !== false)
    .map(k => ({ ...k, contacts: (k.contacts || []).filter(c => c && c.isActive !== false) }));
}

export async function getKontaktVerzeichnis() {
  if (cached && Date.now() - cachedAt < TTL_MS) return cached;
  if (!pending) {
    pending = apiService.getCustomersAdmin()
      .then(resp => {
        cached = nurAktive(resp?.customers);
        cachedAt = Date.now();
        return cached;
      })
      .catch(() => cached || [])
      .finally(() => { pending = null; });
  }
  return pending;
}

export function invalidateKontaktVerzeichnis() {
  cached = null;
  cachedAt = 0;
}
